import { render, staticRenderFns } from "./DeleteModualDeleteMarked.vue?vue&type=template&id=4939120e"
import script from "./DeleteModualDeleteMarked.vue?vue&type=script&lang=js"
export * from "./DeleteModualDeleteMarked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports